import { Button } from 'antd';
import './Button.scss';

const CustomButton = ({ children, ...props }) => {
    return (
        <Button className='customBtn'
            {...props}
        >
            {children}
        </Button>
    );
};

export default CustomButton;
